module.exports = __webpack_public_path__ + "static/img/samajuri (39).06ad402.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (39).jpg
// module id = RqwU
// module chunks = 0